// extracted by mini-css-extract-plugin
export default {"card":"Card_card__riG-s","center":"Card_center__C1oqw","h2h":"Card_h2h__jOwDX","h1h":"Card_h1h__ku2My","ps":"Card_ps__KgSwa"};